import React from "react";

export interface ThemeOverviewProps {
  longDescription?: string;
  objectives?: string[];
  audience?: "adult" | "teen" | "kid" | "teacher";
}

export function ThemeOverview({ longDescription, objectives, audience }: ThemeOverviewProps) {
  const label =
    audience === "kid"
      ? "Ce que tu vas decouvrir :"
      : "Ce que vous allez apprendre :";

  return (
    <section className="space-y-3 rounded-2xl border shadow-sm p-5 bg-white dark:bg-slate-900 dark:border-slate-700">
      {longDescription && <p className="text-sm text-slate-700 dark:text-slate-200">{longDescription}</p>}
      {objectives && objectives.length > 0 && (
        <div className="space-y-2">
          <h2 className="text-sm font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">
            {label}
          </h2>
          <ul className="list-disc list-inside text-sm text-slate-700 dark:text-slate-200 space-y-1">
            {objectives.map((obj) => (
              <li key={obj}>{obj}</li>
            ))}
          </ul>
        </div>
      )}
    </section>
  );
}
